import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import ContaParametro from "model/administracao/cadastro/ContaParametro";
import Pageable from "model/page/Pageable";
import Page from "model/page/Page";
import { api } from "api/api";
import { AxiosError } from "axios";
import Parametro from "model/administracao/cadastro/Parametro";

class ContaParametroService implements BaseServiceCadastros<ContaParametro> {

    pesquisar(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/contaParametro/pesquisar`;

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ContaParametro>((resolve, reject): void => {
            api
                .get(`/contaParametro/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(contaParametro: ContaParametro) {
        return new Promise<ContaParametro>((resolve, reject): void => {
            let url = `/contaParametro/incluir`;
            api
                .post(url, JSON.stringify(contaParametro))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(contaParametro: ContaParametro) {
        return new Promise<ContaParametro>((resolve, reject): void => {
            api
                .put(`/contaParametro/editar`, JSON.stringify(contaParametro))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/contaParametro/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getParametrosDisponiveis(): Promise<Parametro[]> {
        return new Promise<Parametro[]>((resolve, reject): void => {
            api
                .get(`/contaParametro/parametrosDisponiveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarParametro(codigo: string): Promise<ContaParametro> {

        return new Promise<ContaParametro>((resolve, reject): void => {
            api
                .get(`/contaParametro/buscarParametro/${codigo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default ContaParametroService;